module.exports = __webpack_public_path__ + "static/img/xmlx.7afc37d1.png";